
import { Vue, Component, Watch } from 'vue-property-decorator'
import SimpleTable from '@/components/busi/table/simple-table.vue'
import { getPersonInfo, updatePersonInfo } from '@/api/systemset'
import { UserModule } from '@/store/modules/user'
import dayjs from 'dayjs'
import md5 from 'md5'
import { LocalStorage } from '@/utils/storage'
import { RightModule } from '@/store/modules/right'
@Component({
  name: 'personal-info',
  components: {
    SimpleTable
  }
})
export default class PersonalInfo extends Vue {
  // eslint-disable-next-line no-undef
  [x: string]: any
  private activeName = 'info'

  private dictRole = {
    1: '用户',
    2: '代理',
    99: '超级管理员'
  }

  private dayjs = dayjs

  get userId () {
    return UserModule.id
  }

  @Watch('form.userName')
  private stuName () {
    this.form.userName = this.form.userName.replace(/(\u3000|\s)(\u3000|\s)*/g, '')
  }

  private rules = {
    userName: [
      { required: true, message: '请输入真实姓名', trigger: 'change' }
    ],
    phone: [
      { required: true, message: '请输入手机号', trigger: 'change' }
    ]
  }

  private loading = !1

  private form: any = {}

  private iClass: any = {
    hidden: !0
  }

  @Watch('activeName', { immediate: !0, deep: !0 })
  private activeNameChange () {
    this.initData()
  }

  private validate (value: any) {
    const reg = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
    if (!reg.test(value)) {
      return !1
    }
    return !0
  }

  private update () {
    this.iClass.hidden = !this.iClass.hidden
  }

  private async save () {
    (this.$refs.form as any).validate(async () => {
      if (this.form.phone !== '-1' && !this.validate(this.form.phone)) {
        this.$message.error('请输入正确的电话号码')
        return
      }
      if (this.form.password && this.form.password !== this.form.rpassword) {
        this.$message.error('两次输入的密码不一致')
        return
      }
      await updatePersonInfo({
        id: this.form.id,
        userName: this.form.userName,
        phone: this.form.phone,
        pwd: this.form.password ? md5(this.form.password) : -1
      }).then((res: any) => {
        if (res.code === 10000) {
          this.$message(res.message)
        }
      })
    })
  }

  private async initData () {
    this.loading = !0
    await getPersonInfo({
      id: this.userId
    }).then(async (res: any) => {
      if (res.code === 10000) {
        Object.keys(res.object).map((key: any) => {
          const val = res.object[key] === -1 || res.object[key] === '-1' ? '' : res.object[key]
          this.form[key] = val
        })
        this.form.businessNames = res.object.businessNames
        this.form.rpcUserRoleNames = LocalStorage.getObj(RightModule.KEYS.RPC_USER_ROLE_NAMES)
      }
      this.loading = !1
    }).catch(err => {
      this.loading = !1
      this.$message.error(err)
    })
  }

  private handleClick () {
    this.initData()
  }
}
